// /api/fetchClient.ts
import { getSession } from 'next-auth/react';
import { getUserIp } from '@/lib/utils';
import { AuthSession } from 'interfaces';

export const fetchWithAuth = async (
	url: string,
	options: RequestInit = {}
): Promise<Response> => {
	const session = (await getSession()) as AuthSession;
	const ip = await getUserIp();

	const headers = new Headers(options.headers || {});
	if (session?.accessToken) {
		headers.set('Authorization', `Bearer ${session.accessToken}`);
	}
	headers.set('X-User-IP', ip);
	headers.set('Content-Type', 'application/json');

	return fetch(url, {
		...options,
		headers,
	});
};
